module.exports = [
	{
		"id": 1,
		"text": "Is your organisation aware of what the data protection principles are under GDPR?",
		"category": "data-protection-principles",
		"answers": [
			{
				"text": "Yes, we understand them all.",
				"value": 5
			},
			{
				"text": "Yes, most of them.",
				"value": 3
			},
			{
				"text": "No.",
				"value": 0
			},
			{
				"text": "Vaguely.",
				"value": 1
			}
		]
	},
	{
		"id": 2,
		"text": "Has your organisation designed, documented and communicated your processes to deal with data subject rights (DSRs) – that is individuals’ requests to access, amend or delete their personal data or object to data processing within the new timeframes (e.g. subject access requests; right to be forgotten requests; objections to profiling; objections to automatic decision making)?",
		"category": "data-protection-principles",
		"answers": [
			{
				"text": "Yes.",
				"value": 5
			},
			{
				"text": "Partly.",
				"value": 1
			},
			{
				"text": "No.",
				"value": 0
			}
		]
	},
	{
		"id": 3,
		"text": "Has your company put in place a data breach notification procedure to detect report and investigate a personal data breach, together with a response plan?",
		"category": "data-breach-notification-procedure",
		"answers": [
			{
				"text": "Yes.",
				"value": 5
			},
			{
				"text": "Partly.",
				"value": 2
			},
			{
				"text": "No.",
				"value": 0
			}
		]
	},
	{
		"id": 4,
		"text": "Do you have a Data Protection Impact Assessment process in place?",
		"category": "data-protection-impact-assessment",
		"answers": [
			{
				"text": "Yes.",
				"value": 5
			},
			{
				"text": "Partly.",
				"value": 3
			},
			{
				"text": "No.",
				"value": 0
			}
		]
	},
	{
		"id": 5,
		"text": "Has your organisation got to grips with the principle of privacy by design/default?",
		"category": "principle-of-privacy",
		"answers": [
			{
				"text": "Yes.",
				"value": 3
			},
			{
				"text": "We’re working on it.",
				"value": 1
			},
			{
				"text": "No.",
				"value": 0
			},
			{
				"text": "I don’t understand what this means.",
				"value": -1
			}
		]
	},
	{
		"id": 6,
		"text": "Has your organisation undertaken a data-mapping exercise?",
		"category": "data-mapping",
		"answers": [
			{
				"text": "Yes.",
				"value": 3
			},
			{
				"text": "We’re working on it.",
				"value": 1
			},
			{
				"text": "No.",
				"value": 0
			},
			{
				"text": "We’re not going to do this.",
				"value": 0
			}
		]
	},
	{
		"id": 7,
		"text": "Does your company set up and undertake regular compliance audits or reviews in order to identify and rectify issues?",
		"category": "processing-activities",
		"answers": [
			{
				"text": "Yes.",
				"value": 4
			},
			{
				"text": "Partly.",
				"value": 1
			},
			{
				"text": "No.",
				"value": 0
			}
		]
	},
	{
		"id": 8,
		"text": "Has your organisation put in place a system to record processing activities?",
		"category": "processing-activities",
		"answers": [
			{
				"text": "Yes.",
				"value": 4
			},
			{
				"text": "We’re working on it.",
				"value": 1
			},
			{
				"text": "No.",
				"value": 0
			}
		]
	},
	{
		"id": 9,
		"text": "Have you briefed senior management on GDPR?",
		"category": "senior-mgmt-briefing",
		"answers": [
			{
				"text": "Yes, all of them.",
				"value": 3
			},
			{
				"text": "Yes, some of them.",
				"value": 1
			},
			{
				"text": "No.",
				"value": 0
			}
		]
	},
	{
		"id": 10,
		"text": "Does your organisation understand the penalties that can be applied?",
		"category": "training-and-awareness",
		"answers": [
			{
				"text": "Completely.",
				"value": 3
			},
			{
				"text": "We have a good understanding.",
				"value": 2
			},
			{
				"text": "We have some understanding.",
				"value": 1
			},
			{
				"text": "Not at all.",
				"value": 0
			}
		]
	},
	{
		"id": 11,
		"text": "Has your organisation put in place a way of lawfully transferring data internationally?",
		"category": "data-protection-principles",
		"answers": [
			{
				"text": "Yes - with everyone we deal with.",
				"value": 5
			},
			{
				"text": "We have measures in place with most of the organisations we deal with.",
				"value": 3
			},
			{
				"text": "We have measures in place with some we deal with.",
				"value": 1
			},
			{
				"text": "No.",
				"value": 0
			}
		]
	},
	{
		"id": 12,
		"text": "Have you worked out how to be GDPR compliant for hard copy personal data?",
		"category": "data-protection-principles",
		"answers": [
			{
				"text": "Yes.",
				"value": 5
			},
			{
				"text": "No.",
				"value": 0
			},
			{
				"text": "GDPR doesn’t apply to hard copy personal data.",
				"value": -2
			}
		]
	},
	{
		"id": 13,
		"text": "Does your organisation have in place pseudonymisation and anonymisation tools?",
		"category": "data-protection-principles",
		"answers": [
			{
				"text": "Yes.",
				"value": 3
			},
			{
				"text": "No.",
				"value": 0
			},
			{
				"text": "I don’t know.",
				"value": 0
			},
			{
				"text": "I don’t know what these terms mean.",
				"value": 1
			}
		]
	},
	{
		"id": 14,
		"text": "Have you reviewed your policies and procedures to make sure you get consent properly where you need consent from employees, customers and others you deal with?",
		"category": "principle-of-privacy",
		"answers": [
			{
				"text": "Yes, and any necessary updates have been made.",
				"value": 5
			},
			{
				"text": "Yes, but some updates are outstanding.",
				"value": 3
			},
			{
				"text": "Some policies and procedures have been reviewed.",
				"value": 2
			},
			{
				"text": "No.",
				"value": 0
			}
		]
	},
	{
		"id": 15,
		"text": "Has your organisation considered relying on other ways (i.e. not just consent) to ensure the lawful processing of personal data such as \"legitimate expectations\"? ",
		"category": "principle-of-privacy",
		"answers": [
			{
				"text": "Yes for some processing.",
				"value": 4
			},
			{
				"text": "Not at all.",
				"value": 0
			},
			{
				"text": "I don’t know what this means.",
				"value": -1
			}
		]
	},
	{
		"id": 16,
		"text": "Has your marketing department put in place measures to ensure data protection compliance for example with direct marketing?",
		"category": "data-protection-principles",
		"answers": [
			{
				"text": "Yes for some processing.",
				"value": 4
			},
			{
				"text": "Not at all.",
				"value": 0
			},
			{
				"text": "I don’t know what this means.",
				"value": 0
			}
		]
	},
	{
		"id": 17,
		"text": "Has your organisation updated its insurance policy to cover itself for data protection liability issues, in particular breaches?",
		"category": "data-protection-principles",
		"answers": [
			{
				"text": "Yes.",
				"value": 3
			},
			{
				"text": "No.",
				"value": 0
			},
			{
				"text": "I don’t know.",
				"value": 0
			},
			{
				"text": "We have taken the decision to self-insure.",
				"value": 3
			},
			{
				"text": "We use an insurance captive for this.",
				"value": 3
			}
		]
	},
	{
		"id": 18,
		"text": "Have you identified who your data protection regulator(s) will be?",
		"category": "data-protection-principles",
		"answers": [
			{
				"text": "Yes.",
				"value": 1
			},
			{
				"text": "No.",
				"value": 0
			}
		]
	},
	{
		"id": 19,
		"text": "Is your organisation ready if a regulator comes to audit it?",
		"category": "data-protection-principles",
		"answers": [
			{
				"text": "Yes.",
				"value": 5
			},
			{
				"text": "No.",
				"value": 0
			},
			{
				"text": "I don’t know.",
				"value": 0
			}
		]
	},
	{
		"id": 20,
		"text": "Has your company provided awareness training on GDPR to all its staff?",
		"category": "training-and-awareness",
		"answers": [
			{
				"text": "Yes, to all staff.",
				"value": 5
			},
			{
				"text": "Some, but not to all staff.",
				"value": 2
			},
			{
				"text": "We have prepared some training, but we have not delivered it.",
				"value": 0
			},
			{
				"text": "No.",
				"value": 0
			}
		]
	},
	{
		"id": 21,
		"text": "Can you document your training?",
		"category": "training-and-awareness",
		"answers": [
			{
				"text": "Yes.",
				"value": 3
			},
			{
				"text": "No.",
				"value": 0
			},
			{
				"text": "I don't know.",
				"value": 0
			}
		]
	},
	{
		"id": 22,
		"text": "Does your organisation have written procedures in place which are communicated to all employees, contractors etc. who handle personal data?",
		"category": "data-protection-principles",
		"answers": [
			{
				"text": "Yes.",
				"value": 5
			},
			{
				"text": "Employees have seen these policies, but contractors and vendors who access personal data have not.",
				"value": 3
			},
			{
				"text": "No.",
				"value": 0
			},
			{
				"text": "I don't know.",
				"value": 0
			}
		]
	},
	{
		"id": 23,
		"text": "Has your company appointed a Data Protection Officer?",
		"category": "data-protection-principles",
		"answers": [
			{
				"text": "Yes, in every country where we operate.",
				"value": 2
			},
			{
				"text": "Yes, in some countries.",
				"value": 1
			},
			{
				"text": "No.",
				"value": 0
			}
		]
	},
	{
		"id": 24,
		"text": "Has your company reviewed its vendor contracts to check that you can respond within the new time limits and to make sure that you have proper written agreements in place with vendors?",
		"category": "principle-of-privacy",
		"answers": [
			{
				"text": "Yes, all vendor contracts have been reviewed.",
				"value": 5
			},
			{
				"text": "Some, but not all.",
				"value": 2
			},
			{
				"text": "No.",
				"value": 0
			}
		]
	},
	{
		"id": 25,
		"text": "Has your company reviewed all key practical aspects such as data retention and destruction through all means of collecting data used by the business (e.g. data collected online and offline, data stored in filing cabinets)?",
		"category": "data-protection-principles",
		"answers": [
			{
				"text": "Yes.",
				"value": 4
			},
			{
				"text": "Partly",
				"value": 2
			},
			{
				"text": "No.",
				"value": 0
			}
		]
	},
	{
		"id": 26,
		"text": "When did you last review your main website privacy policy?",
		"category": "principle-of-privacy",
		"answers": [
			{
				"text": "This year.",
				"value": 4
			},
			{
				"text": "1 – 2 years ago.",
				"value": 2
			},
			{
				"text": "More than 2 years ago.",
				"value": 0
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/gdpr-assessment-tool/content/quiz.json
// module id = 396
// module chunks = 0